import gql from 'graphql-tag';

import { LINK_PREVIEW_METADATA_FRAGMENT } from '../LinkMetadata/linkPreviewMetadata';
import { MENTIONS_PLEX_REGISTERED_USER_FRAGMENT } from '../PlexRegisteredUser/mentionsPlexRegistereduser';

export const CHANGE_EVENT_COMMENT_FRAGMENT = gql`
  fragment changeEventComment on Comment {
    id
    deleted
    type
    body
    currentUserReactions
    mentions {
      ...mentionsPlexRegisteredUser
    }
    links {
      ...linkPreviewMetadata
    }
    commenter {
      id
      name
      picture
      jobTitle
    }
    createdAt
  }

  ${MENTIONS_PLEX_REGISTERED_USER_FRAGMENT}
  ${LINK_PREVIEW_METADATA_FRAGMENT}
`;
